var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnalysis2 = function SvgAnalysis2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4771E0",
    d: "M16.734 10.688H2.812V.89c0-.258-.257-.516-.515-.516H1.266A.53.53 0 0 0 .75.891v10.828c0 .58.451 1.031 1.031 1.031h14.953a.53.53 0 0 0 .516-.516v-1.03c0-.259-.258-.517-.516-.517m-1.03-9.282h-3.836c-.677 0-1.031.838-.548 1.322l1.064 1.063-2.353 2.353L7.646 3.79a.994.994 0 0 0-1.45 0L3.973 6.015a.506.506 0 0 0 0 .709l.74.74a.506.506 0 0 0 .71 0l1.515-1.482L9.29 8.335a.994.994 0 0 0 1.45 0l3.094-3.094 1.064 1.064c.483.483 1.288.129 1.288-.548V1.922c.033-.258-.225-.516-.483-.516"
  })));
};
export default SvgAnalysis2;